<mat-form-field appearance="outline" class="hmt-form-field organization-field">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  <input
    type="text"
    matInput
    [formControl]="searchControl"
    [placeholder]="placeholder()"
    [matAutocomplete]="orgAutocomplete"
    autocomplete="off"
    (focus)="onInputFocus()"
  />
  <mat-autocomplete
    #orgAutocomplete="matAutocomplete"
    class="searchable-autocomplete"
    [displayWith]="displayOrganization"
    (optionSelected)="onOrganizationOptionSelected($event.option.value)"
    [autoActiveFirstOption]="false"
  >
    @for (org of filteredOrganizations(); track org.id) {
      <mat-option [value]="org">
        {{ org.orgName }}
      </mat-option>
    }
    
    @if (filteredOrganizations().length === 0 && !loading()) {
      <mat-option disabled>
        No organizations found
      </mat-option>
    }
    
    @if (loading() && filteredOrganizations().length > 0) {
      <mat-option disabled class="loading-option">
        <mat-spinner diameter="16"></mat-spinner>
        <span>Loading more organizations...</span>
      </mat-option>
    }
  </mat-autocomplete>
  
  @if (loading()) {
    <mat-spinner matSuffix diameter="20"></mat-spinner>
  }
</mat-form-field>

